<template>
    <router-view></router-view>
</template>

<script setup lang="ts">
import { useClearCachesOnFormSubmission } from '@/composables/useClearCachesOnFormSubmission';

useClearCachesOnFormSubmission();
</script>
